import React from 'react'
import Navbar from 'components/Navbar'
import { CloseButton } from './CloseButton'
import { PrototypeName } from './PrototypeName'
import * as Styles from './PrototypeViewHeader.styles'
import { HistoryNavigation } from './HistoryNavigation'
import { PrototypeMenu } from './PrototypeMenu'
import { HeaderActionButton, HeaderActionLink } from './HeaderAction'
import { ReactComponent as FullScreenSvg } from '@sketch/icons/arrow-top-bottom-diagonal-16-svg'
import { ReactComponent as ArtboardSvg } from '@sketch/icons/artboard-16-svg'
import {
  usePrototypeViewContext,
  useArtboardDetailPathname,
  useInitialPrototypeArtboardId,
} from '../../hooks'
import { ShareViewsNavigationContextProvider } from '../../../../shares/utils/shareViewsNavigation'

export function PrototypeViewHeader() {
  const artboardDetailPathname = useArtboardDetailPathname()
  const { enterFullscreen, isFullscreen } = usePrototypeViewContext()
  const initialArtboardId = useInitialPrototypeArtboardId()

  if (isFullscreen) {
    return null
  }

  return (
    <ShareViewsNavigationContextProvider>
      <Navbar data-testid="prototype-view-header">
        <Styles.Section>
          <Styles.Close>
            <CloseButton />
          </Styles.Close>
          <Styles.Name>
            <PrototypeName />
          </Styles.Name>
        </Styles.Section>
        <Styles.Section>
          <Styles.ItemDesktop>
            <HistoryNavigation initialArtboardId={initialArtboardId} />
          </Styles.ItemDesktop>
          <Styles.ItemDesktop>
            <HeaderActionLink
              to={artboardDetailPathname}
              icon={<ArtboardSvg />}
            >
              View Artboard
            </HeaderActionLink>
          </Styles.ItemDesktop>
          <Styles.ItemDesktop>
            <HeaderActionButton
              onClick={enterFullscreen}
              icon={<FullScreenSvg />}
            >
              Full Screen
            </HeaderActionButton>
          </Styles.ItemDesktop>
          <Styles.Item>
            <PrototypeMenu initialArtboardId={initialArtboardId} />
          </Styles.Item>
        </Styles.Section>
      </Navbar>
    </ShareViewsNavigationContextProvider>
  )
}

/**
 * Empty version of the prototype header to display
 * while the prototype is loading or if there is an error.
 */
export function PrototypeViewHeaderEmpty() {
  return (
    <Navbar>
      <Styles.Close>
        <CloseButton />
      </Styles.Close>
    </Navbar>
  )
}
